<template>
    <van-nav-bar
  title="重要提示"
  left-text="返回"
  left-arrow
  @click-left="onClickLeft"
  @click-right="onClickRight"
/>

    <p v-html="info.dataread.description" class="el-div" color="#1989fa" background="#ecf9ff"></p>

</template>
<style>
.el-div{
    width: calc(100% - 40px);
  margin: 0 auto;
  padding: 0 20px;
}
</style>
<script>
import { reactive } from "vue";
import { getInfoBaseByType } from "../../http/api.ts";

export default {
setup() {
    let info = reactive({
      dataread: "",});
    let dataFun = async () => {
      await getInfoBaseByType("11").then((res) => {
        info.dataread = res.datas;
      });
    };
     dataFun();
    return {info};
},methods:{
    onClickLeft(){
        history.go(-1);
    }
}
}
</script>